/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Edit_ProducerInputs */

const en_edit_producer = /** @type {(inputs: Edit_ProducerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit Producer`)
};

const es_edit_producer = /** @type {(inputs: Edit_ProducerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editar productor`)
};

/**
* | output |
* | --- |
* | "Edit Producer" |
*
* @param {Edit_ProducerInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const edit_producer = /** @type {((inputs?: Edit_ProducerInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Edit_ProducerInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_edit_producer(inputs)
	return es_edit_producer(inputs)
});